module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-cbfd2c83.png";